<template >
    <div class="pages marketingData">
        <div class="f1">
            <div class="l1">
                <div class="title">
                    <div class="txt">
                        <img src="../../assets/images/newIcon/yingxiao_huizong_icon.png" alt="">
                        营销汇总
                        <span>系统营销行为所产生的效益</span>
                    </div>
                    <div class="sx">
                        <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
                            <el-radio-button label="1">昨日</el-radio-button>
                            <el-radio-button label="2">7天</el-radio-button>
                            <el-radio-button label="3">15天</el-radio-button>
                            <el-radio-button label="4">30天</el-radio-button>
                        </el-radio-group>
                        <el-date-picker
                            v-model="time1"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <ul class="list">
                    <li @click="changeType(1)" :class="types==1 ?'active' : ''">
                    <div class="d1">
                        <img v-show="types!=1" src="../../assets/images/newIcon/yingxiao_shouru_icon.png" alt="">
                        <img v-show="types==1" src="../../assets/images/newIcon/yingxiao_shouruwhite_icon.png" alt="">
                    </div>
                    <div class="d2">
                        <p>经营收入 
                                <el-tooltip v-show="types!=1"  class="item" effect="dark" content="所选周期内累计的营销收入，包含自然购买与营销活动" placement="right">
                                <img  src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <el-tooltip v-show="types==1"  class="item" effect="dark" content="所选周期内累计的营销收入，包含自然购买与营销活动" placement="right">
                                <img  src="../../assets/images/newIcon/tishi_white_icon.png" alt="">
                                </el-tooltip>
                            </p>
                        <p>36,254</p>
                    </div>
                    </li>
                    <li @click="changeType(2)" :class="types==2 ?'active' : ''">
                    <div class="d1">
                        <img v-show="types!=2" src="../../assets/images/newIcon/yingxiao_cishu_icon.png" alt="">
                        <img v-show="types==2" src="../../assets/images/newIcon/yingxiao_cishuwhite_icon.png" alt="">
                    </div>
                    <div class="d2">
                        <p>营销次数 
                                <el-tooltip v-show="types!=2" class="item" effect="dark" content="所选周期内运行的营销活动次数（指定日期范围内创建的活动）" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <el-tooltip v-show="types==2" class="item" effect="dark" content="所选周期内运行的营销活动次数（指定日期范围内创建的活动）" placement="right">
                               <img src="../../assets/images/newIcon/tishi_white_icon.png" alt="">
                                </el-tooltip>
                                  
                            </p>
                        <p>36,254 </p>
                    </div>
                    </li>
                    <li @click="changeType(3)" :class="types==3 ?'active' : ''">
                    <div class="d1">
                        <img v-show="types!=3" src="../../assets/images/newIcon/yingxiao_chuda_icon.png" alt="">
                        <img v-show="types==3" src="../../assets/images/newIcon/yingxiao_chudawhite_icon.png" alt="">
                    </div>
                    <div class="d2">
                        <p>触达次数 
                                <el-tooltip  v-show="types!=3" class="item" effect="dark" content="所选周期内推送的用户数量，计算规则为：营销活动触达的累计汇总。（如发短信，选择1000人发，则单次触达次数为1000）" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <el-tooltip  v-show="types==3" class="item" effect="dark" content="所选周期内推送的用户数量，计算规则为：营销活动触达的累计汇总。（如发短信，选择1000人发，则单次触达次数为1000）" placement="right">
                                 <img src="../../assets/images/newIcon/tishi_white_icon.png" alt="">
                                </el-tooltip>
                            </p>
                        <p>36,254 </p>
                    </div>
                    </li>
                    <li @click="changeType(4)" :class="types==4 ?'active' : ''">
                    <div class="d1">
                        <img v-show="types!=4" src="../../assets/images/newIcon/yingxiao_wancheng_icon.png" alt="">
                        <img v-show="types==4" src="../../assets/images/newIcon/yingxiao_wanchengwhite_icon.png" alt="">
                    </div>
                    <div class="d2">
                        <p>完成次数 
                                <el-tooltip  v-show="types!=4" class="item" effect="dark" content="所选周期内营销活动的点击参与次数（例如短信、公众号推送1000人，点击50人，参与次数为50）" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                  <el-tooltip  v-show="types==4" class="item" effect="dark" content="所选周期内营销活动的点击参与次数（例如短信、公众号推送1000人，点击50人，参与次数为50）" placement="right">
                                 <img src="../../assets/images/newIcon/tishi_white_icon.png" alt="">
                                </el-tooltip>
                            </p>
                        <p>36,254 </p>
                    </div>
                    </li>
                </ul>
                <div class="chat1">
                    <div id="income"></div>
                </div>
            </div>
            <div class="l2">
                <div class="title">
                    <div class="txt">
                        <img src="../../assets/images/newIcon/yingxiao_loudou_icon.png" alt="">
                        线上参与活动漏斗
                        <span>线上互动关键动作数据汇总</span>
                    </div>
                </div>
                <div class="t2">2021-06-28～2021-07-27 | 过去30天</div>
                <div class="cans">
                    <div>
                        <p>24.82%</p>
                        <p>参与-完成转化率</p>
                    </div>
                    <div>
                        <p>24.82%</p>
                        <p>完成-支付转化率</p>
                    </div>
                    <div>
                        <p>24.82%</p>
                        <p>参与-支付转化率</p>
                    </div>
                </div>
                <ul class="lis">
                    <li>
                        <div class="txt">
                            <p> <span>1</span>参与活动人数</p>
                            <p>12,472人</p>
                        </div>
                        <div>
                            <el-progress color="#2967FF" :text-inside="true" :stroke-width="36" :percentage="100"></el-progress>
                        </div>
                    </li>
                    <li>
                        <div class="txt">
                            <p> <span>2</span>完成活动人数</p>
                            <p>3,015人</p>
                        </div>
                        <div>
                            <el-progress color="#FCB73B" :text-inside="true" :stroke-width="36" :percentage="70"></el-progress>
                        </div>
                    </li>
                    <li>
                        <div class="txt">
                            <p> <span>3</span>支付人数</p>
                            <p>12,472人</p>
                        </div>
                        <div>
                            <el-progress color="#2967FF" :text-inside="true" :stroke-width="36" :percentage="30"></el-progress>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="f2">
            <div class="title">
                <div class="txt">
                    <img src="../../assets/images/newIcon/yingxiao_gaiyao_icon.png" alt="">
                    营销概要
                    <span>近期完成的营销活动数据概览</span>
                </div>
            </div>
            <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',fontSize:'12px',textAlign: 'center'}"
                style="width: 100%"
                :cell-style="{padding:'15px 0px',fontSize:'12px',textAlign: 'center'}"
                >
                <el-table-column
                prop="name"
                label="活动名称"
                show-overflow-tooltip
                min-width="20%">

                </el-table-column>

                <el-table-column
                prop="number"
                label="活动类型"
                min-width="20%">
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="参与人数"
                min-width="20%">
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="完成人数"
                min-width="20%">
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="活动完成率"
                min-width="20%">
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
const QUERY = {
  page_index: 1,
  page_size: 10,
};
export default {
    data(){
        return {
            query: JSON.parse(JSON.stringify(QUERY)),
            total:4,
            tabPosition:"1",
            time1:"",
            types:"1",
            tableData: [{
                name: '营销活动优惠',
                number:"人群营销",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
               name: '营销活动优惠',
                number:"人群营销",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
               name: '营销活动优惠',
                number:"人群营销",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '营销活动优惠',
                number:"人群营销",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
            }]
        }
        
    },
    mounted() {
        this.init();
    },
    methods: {
        init(){
            let d1=[
                {data:"2019.01.1",name:'经营收入',val:300},
                {data:"2019.01.2",name:'经营收入',val:400},
                {data:"2019.01.3",name:'经营收入',val:600},
                {data:"2019.01.4",name:'经营收入',val:1000},
                {data:"2019.01.5",name:'经营收入',val:800},
                {data:"2019.01.6",name:'经营收入',val:500},
                {data:"2019.01.7",name:'经营收入',val:200},
            ]
            let data=[...d1];

            const chart = new this.$chart({
            container: 'income',
            autoFit: true,
            height: 340,
            padding:[40,60,80,60]
            });
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            });

            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });
            chart
            .line()
            .position('data*val')
            .color('name',["#5292FF"])
            .shape('smooth');
            // chart
            // .point()
            // .position('data*val')
            // .color('name')
            // .shape('circle');

            chart.render();
        },
        changeType(type){
            this.types=type;
        },
        handleSizeChange(val) {
        this.query.page_size = val;
        // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
        
    },
}
</script>
<style lang="less" scoped>
    @media screen and (min-width: 1200px) and (max-width: 1366px){
         ::v-deep .el-radio-button__inner{
            padding-right:10px !important;
         }
    }
   
    .marketingData{
        .f1{
            display: flex;
            justify-content: space-between;
            /deep/ .el-radio-button--mini .el-radio-button__inner{
                font-size:12px;
            }
            .l1{
                width:64%;
                .list{
                 display: flex;
                 justify-content: space-between;
                 li{
                     width:24%;
                     display: flex;
                     justify-content: center;
                    padding: 25px 15px;
                    border-radius: 6px;
                     background: #fff;
                     box-sizing: border-box;
                    .d1{
                        display: flex;
                        align-items: center;
                        margin-right:15px;
                        img{
                            width:44px;
                        }
                       
                         
                     }
                    .d2{
                        img{
                            width:16px;
                            vertical-align: bottom;
                        }
                        p{
                            &:first-child{
                                margin-bottom:6px;
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(37, 49, 62, 0.85);
                            }
                            &:last-child{
                                font-size: 24px;
                                font-weight: bold;
                                color: #171E26;
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #7E858C;
                                    padding-left: 15px;
                                    &:last-child{
                                        padding-left: 5px;
                                        font-weight: bold;
                                        color: #FF4343;
                                    }
                                }
                            }
                                
                        }
                    }
                 }
                
                 .active{
                     background: #327EFF;
                     p{
                         color:#fff !important;
                     }
                 }
                }
                .chat1{
                     margin-top:15px;
                     background: #fff;
                 }
            }
            .l2{
                padding:30px;
                border-radius: 6px;
                width:35%;
                background: #fff;
                box-sizing: border-box;
                .t2{
                    margin-top:12px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                }
                .cans{
                    margin-top:30px;
                    display: flex;
                    justify-content: space-between;
                    div{
                        p{
                            font-size: 24px;
                            font-weight: bold;
                            color: #327EFF;
                            &:last-child{
                                margin-top:10px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #666666;
                            }
                        }
                    }
                }
                .lis{
                    li{
                        margin-top:30px;
                        &:first-child{
                            /deep/ .el-progress-bar__inner{
                               background: linear-gradient(180deg, #3B9BFF 0%, #2967FF 100%);
                            }
                        }
                        &:nth-child(2){
                            .txt{
                                span{
                                    color: #FA6400;
                                    background: rgba(254, 160, 81, 0.18);
                                }
                            }
                            /deep/ .el-progress-bar__inner{
                                background: linear-gradient(180deg, #FCB73B 0%, #FF925F 100%) !important;
                            }
                        }
                        &:nth-child(3){
                            .txt{
                                span{
                                    color: #23C3BD;
                                    background: rgba(62, 218, 214, 0.25);
                                }
                            }
                            /deep/ .el-progress-bar__inner{
                                background: linear-gradient(180deg, #49E3E0 0%, #23C3BD 100%);
                            }
                            
                        }
                    }
                    .txt{
                        margin-bottom:15px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        p{
                            span{
                                display: inline-block;
                                margin-right:15px;
                                width: 24px;
                                height: 24px;
                                background: rgba(0, 145, 255, 0.14);
                                text-align: center;
                                line-height: 24px;
                                border-radius: 3px;
                                font-size: 14px;
                                font-weight: 500;
                                color: #0091FF;
                            }
                        }
                    }
                    /deep/ .el-progress-bar__outer{
                        border-radius: 0;
                    }
                    /deep/ .el-progress-bar__inner{
                        border-radius: 0;
                    }
                    /deep/ .el-progress-bar__innerText{
                        display: none;
                    }
                }
            }
        }
        .f2{
            margin-top:30px;
            // padding:30px;
            background: #fff;
            .title{
                padding:15px;
            }
        }
        .page{
            /deep/ .el-pagination .btn-prev{
                margin-right:10px;
            }
            /deep/ .el-pagination .btn-next{
                margin-left:10px;
            }
        }
        .title{
            display: flex;
            justify-content: space-between;
            margin-bottom:15px;
            .txt{
                display: flex;
                align-items: flex-end;
                font-size: 16px;
                font-weight: 600;
                color: #333940;
                img{
                    margin-right:10px;
                    width:20px;
                    vertical-align: middle;
                }
                span{
                    padding-left:15px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                }
            }
            .sx{
                display: flex;
                align-items: center;
                /deep/ .el-radio-button__inner, .el-radio-group{
                    margin:0 !important;
                    padding-right:15px;
                }
                /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
                    width:210px !important;
                }
                /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                    background: #fff;
                    color:#327EFF;
                    //  border:1px solid #327EFF;
                }
            }
            
        }
    }
</style>